import { handleCustomError } from '@/config/errorHandling';
import { isNil } from 'lodash';

export function getValueOrFallback(value: any, fallback: any, error: string) {
    if (isNil(value)) {
        handleCustomError(error);
        return fallback;
    }
    return value;
}
